export default __webpack_public_path__ + "assets/videoShareVimeo.94127dd6.gif";